// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

//Contact Module const

export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';

export const FETCH_ALL_CONTACT = 'fetch_all_contact';
export const FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
export const ADD_FAVOURITE = 'add_favourite';
export const ON_CONTACT_SELECT = 'on_contact_select';
export const ON_ADD_CONTACT = 'on_add_contact';
export const ON_CONTACT_CLOSE = 'on_contact_close';
export const ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
export const ON_SAVE_CONTACT = 'on_save_contact';
export const ON_DELETE_CONTACT = 'on_delete_contact';
export const ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
export const FILTER_CONTACT = 'filter_contact';
export const GET_ALL_CONTACT = 'get_all_contact';
export const GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
export const ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
export const UPDATE_SEARCH_USER = 'update_search_user';
export const ON_TOGGLE_DRAWER = 'on_toggle_drawer';
export const HANDLE_REQUEST_CLOSE = 'handle_request_close';
export const HIDE_CONTACT_LOADER = 'hide_contact_loader';

//Auth const
export const SIGNUP_USER = 'signup_user';
export const SIGNUP_USER_SUCCESS = 'signup_user_success';
export const SIGNIN_GOOGLE_USER = 'signin_google_user';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
export const SIGNIN_FACEBOOK_USER = 'signin_facebook_user';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
export const SIGNIN_TWITTER_USER = 'signin_twitter_user';
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
export const SIGNIN_GITHUB_USER = 'signin_github_user';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';



// Users Info const
export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_ERROR = "GET_USERS_ERROR";
export const GET_USERS_LOADING =  "GET_USERS_LOADING";
export const GET_SINGLE_USER = "GET_SINGLE_USER";
export const GET_SINGLE_USER_SUCCESS = "GET_SINGLE_USER_SUCCESS";
export const GET_SINGLE_USER_ERROR = "GET_SINGLE_USER_ERROR";
export const GET_MORE_USERS =  "GET_MORE_USERS";
export const GET_MORE_USERS_LOADING =  "GET_MORE_USERS_LOADING";
export const GET_MORE_USERS_SUCCESS =  "GET_MORE_USERS_SUCCESS";
export const GET_MORE_USERS_ERROR = "GET_MORE_USERS_ERROR";
export const GET_USERS_ROWS_PER_PAGE =  "GET_USERS_ROWS_PER_PAGE";
export const GET_USERS_PAGE_NUMBER =  "GET_USERS_PAGE_NUMBER";
export const UPDATE_USER = "UPDATE_USER";
// Doctors Info const
export const GET_DOCTORS = "GET_DOCTORS";
export const GET_DOCTORS_SUCCESS = "GET_DOCTORS_SUCCESS";
export const GET_DOCTORS_ERROR = "GET_DOCTORS_ERROR";
export const GET_DOCTORS_LOADING =  "GET_DOCTORS_LOADING";
export const GET_SINGLE_DOCTOR = "GET_SINGLE_DOCTOR";
export const GET_SINGLE_DOCTOR_SUCCESS = "GET_SINGLE_DOCTOR_SUCCESS";
export const GET_SINGLE_DOCTOR_ERROR = "GET_SINGLE_DOCTOR_ERROR";
export const GET_MORE_DOCTORS =  "GET_MORE_DOCTORS";
export const GET_MORE_DOCTORS_LOADING =  "GET_MORE_DOCTORS_LOADING";
export const GET_MORE_DOCTORS_SUCCESS =  "GET_MORE_DOCTORS_SUCCESS";
export const GET_MORE_DOCTORS_ERROR = "GET_MORE_DOCTORS_ERROR";
export const GET_DOCTORS_ROWS_PER_PAGE =  "GET_DOCTORS_ROWS_PER_PAGE";
export const GET_DOCTORS_PAGE_NUMBER = "GET_DOCTORS_PAGE_NUMBER";
export const DELETE_DOCTOR = "DELETE_DOCTOR";
export const ADD_DOCTOR = "ADD_DOCTOR";
export const UPDATE_DOCTOR = "UPDATE_DOCTOR";
// Hospital Info const
export const GET_HOSPITALS = "GET_HOSPITALS";
export const GET_HOSPITALS_SUCCESS = "GET_HOSPITALS_SUCCESS";
export const GET_HOSPITALS_ERROR = "GET_HOSPITALS_ERROR";
export const GET_HOSPITALS_LOADING =  "GET_HOSPITALS_LOADING";
export const GET_SINGLE_HOSPITAL = "GET_SINGLE_HOSPITAL";
export const GET_SINGLE_HOSPITAL_SUCCESS = "GET_SINGLE_HOSPITAL_SUCCESS";
export const GET_SINGLE_HOSPITAL_ERROR = "GET_SINGLE_HOSPITAL_ERROR";
export const GET_MORE_HOSPITALS =  "GET_MORE_HOSPITALS";
export const GET_MORE_HOSPITALS_LOADING =  "GET_MORE_HOSPITALS_LOADING";
export const GET_MORE_HOSPITALS_SUCCESS =  "GET_MORE_HOSPITALS_SUCCESS";
export const GET_MORE_HOSPITALS_ERROR = "GET_MORE_HOSPITALS_ERROR";
export const GET_HOSPITALS_ROWS_PER_PAGE =  "GET_HOSPITALS_ROWS_PER_PAGE";
export const GET_HOSPITALS_PAGE_NUMBER =  "GET_HOSPITALS_PAGE_NUMBER";
export const UPDATE_HOSPITAL = "UPDATE_HOSPITAL";
export const DELETE_HOSPITAL = "DELETE_HOSPITAL";
export const ADD_HOSPITAL = "ADD_HOSPITAL";
export const ADD_HTMLCONTENT = "ADD_HTMLCONTENT";
export const GET_HTMLCONTENT = "GET_HTMLCONTENT";
export const GET_HTMLCONTENT_SUCCESS = "GET_HTMLCONTENT_SUCCESS";
export const GET_HTMLCONTENT_ERROR = "GET_HTMLCONTENT_ERROR";
export const GET_HTMLCONTENT_LOADING =  "GET_HTMLCONTENT_LOADING";
export const GET_HTMLCONTENT_ROWS_PER_PAGE =  "GET_HTMLCONTENT_ROWS_PER_PAGE";
export const GET_HTMLCONTENT_PAGE_NUMBER =  "GET_HTMLCONTENT_PAGE_NUMBER";
export const GET_MORE_HTMLCONTENT = "GET_MORE_HTMLCONTENT";
export const GET_MORE_HTMLCONTENT_LOADING = "GET_MORE_HTMLCONTENT_LOADING";



// Blogs Info const
export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_ERROR = "GET_BLOGS_ERROR";
export const GET_BLOGS_LOADING =  "GET_BLOGS_LOADING";
export const GET_MORE_BLOGS =  "GET_MORE_BLOGS";
export const GET_MORE_BLOGS_LOADING =  "GET_MORE_BLOGS_LOADING";
export const GET_MORE_BLOGS_SUCCESS =  "GET_MORE_BLOGS_SUCCESS";
export const GET_MORE_BLOGS_ERROR = "GET_MORE_BLOGS_ERROR";
export const GET_BLOGS_ROWS_PER_PAGE =  "GET_BLOGS_ROWS_PER_PAGE";
export const GET_BLOGS_PAGE_NUMBER = "GET_BLOGS_PAGE_NUMBER";
export const UPDATE_BLOG = "UPDATE_BLOG";
export const DELETE_BLOG = "DELETE_BLOG";
export const ADD_BLOG = "ADD_BLOG";

//ADMIN Info Const
export const GET_ADMIN = "GET_ADMIN";
export const GET_ADMIN_SUCCESS = "GET_ADMIN_SUCCESS";
export const GET_ADMIN_ERROR = "GET_ADMIN_ERROR";
export const GET_ADMIN_LOADING =  "GET_ADMIN_LOADING";
export const GET_ADMIN_ROWS_PER_PAGE =  "GET_ADMIN_ROWS_PER_PAGE";
export const GET_ADMIN_PAGE_NUMBER = "GET_ADMIN_PAGE_NUMBER";


// FAQ Info const
export const GET_FAQ = "GET_FAQ";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_ERROR = "GET_FAQ_ERROR";
export const GET_FAQ_LOADING =  "GET_FAQ_LOADING";
export const GET_MORE_FAQ =  "GET_MORE_FAQ";
export const GET_MORE_FAQ_LOADING =  "GET_MORE_FAQ_LOADING";
export const GET_MORE_FAQ_SUCCESS =  "GET_MORE_FAQ_SUCCESS";
export const GET_MORE_FAQ_ERROR = "GET_MORE_FAQ_ERROR";
export const GET_FAQ_ROWS_PER_PAGE =  "GET_FAQ_ROWS_PER_PAGE";
export const GET_FAQ_PAGE_NUMBER = "GET_FAQ_PAGE_NUMBER";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const DELETE_FAQ = "DELETE_FAQ";
export const ADD_FAQ = "ADD_FAQ";

//Company Info
export const GET_COMPANYINFO = "GET_COMPANYINFO";
export const GET_COMPANYINFO_SUCCESS = "GET_COMPANYINFO_SUCCESS";
export const GET_COMPANYINFO_ERROR = "GET_COMPANYINFO_ERROR";
export const GET_COMPANYINFO_LOADING = "GET_COMPANYINFO_LOADING";

// Appointments
export const GET_APPOINTMENTDASH = "GET_APPOINTMENTDASH";
export const GET_APPOINTMENTDASH_SUCCESS = "GET_APPOINTMENTDASH_SUCCESS";
export const GET_APPOINTMENTDASH_ERROR = "GET_APPOINTMENTDASH_ERROR";
export const GET_APPOINTMENTDASH_LOADING = "GET_APPOINTMENTDASH_LOADING";
export const GET_APPOINTMENTS = "GET_APPOINTMENTS";
export const GET_APPOINTMENTS_SUCCESS = "GET_APPOINTMENTS_SUCCESS";
export const GET_APPOINTMENTS_ERROR = "GET_APPOINTMENTS_ERROR";
export const GET_APPOINTMENTS_LOADING = "GET_APPOINTMENTS_LOADING";
export const GET_APPOINTMENTS_ROWS_PER_PAGE = "GET_APPOINTMENTS_ROWS_PER_PAGE";
export const GET_APPOINTMENTS_PAGE_NUMBER = "GET_APPOINTMENTS_PAGE_NUMBER";
export const GET_MORE_APPOINTMENTS = "GET_MORE_APPOINTMENTS";
export const GET_MORE_APPOINTMENTS_LOADING = "GET_MORE_APPOINTMENTS_LOADING";

// Payments & Payouts
export const GET_PAYOUTS = "GET_PAYOUTS";
export const GET_PAYMENTS = "GET_PAYMENTS";
export const GET_PAYMENTS_SUCCESS = "GET_PAYMENTS_SUCCESS";
export const GET_PAYOUTS_SUCCESS = "GET_PAYOUTS_SUCCESS";
export const GET_PAYMENTS_ERROR = "GET_PAYMENTS_ERROR";
export const GET_PAYOUTS_ERROR = "GET_PAYOUTS_ERROR";
export const GET_PAYMENTS_LOADING = "GET_PAYMENTS_LOADING";
export const GET_PAYOUTS_LOADING = "GET_PAYOUTS_LOADING";
export const GET_PAYMENTS_ROWS_PER_PAGE = "GET_PAYMENTS_ROWS_PER_PAGE";
export const GET_PAYOUTS_ROWS_PER_PAGE = "GET_PAYOUTS_ROWS_PER_PAGE";
export const GET_PAYMENTS_PAGE_NUMBER = "GET_PAYMENTS_PAGE_NUMBER";
export const GET_PAYOUTS_PAGE_NUMBER = "GET_PAYOUTS_PAGE_NUMBER";
export const GET_MORE_PAYMENTS = "GET_MORE_PAYMENTS";
export const GET_MORE_PAYMENTS_LOADING = "GET_MORE_PAYMENTS_LOADING";

// Notifications
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_ERROR = "GET_NOTIFICATIONS_ERROR";
export const GET_NOTIFICATIONS_LOADING = "GET_NOTIFICATIONS_LOADING";
export const ADD_NOTIFICATION_TO_STORE = "ADD_NOTIFICATION_TO_STORE";
export const DELETE_NOTIFICATION_FROM_STORE = "DELETE_NOTIFICATION_FROM_STORE";

// Illness Action Types
export const GET_ILLNESS_LIST = "GET_ILLNESS";
export const GET_ILLNESS_LIST_SUCCESS = "GET_ILLNESS_SUCCESS";
export const GET_ILLNESS_LIST_ERROR = "GET_ILLNESS_ERROR";
export const GET_ILLNESS_LIST_LOADING = "GET_ILLNESS_LOADING";
export const ADD_ILLNESS = "ADD_ILLNESS";
export const REMOVE_ILLNESS = "REMOVE_ILLNESS";

// Chat Module const

export const FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
export const FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
export const FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
export const FILTER_USERS = 'filter_users';
export const ON_SELECT_USER = 'on_select_user';
export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';
export const USER_INFO_STATE = 'user_info_state';
export const SUBMIT_COMMENT = 'submit_comment';
export const UPDATE_MESSAGE_VALUE = 'update_message_value';
export const UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';

//// Mail Module const


export const ADD_LABEL = 'ADD_LABEL';
export const GET_ALL_MAIL = 'get_all_mail';
export const FETCH_ALL_MAIL = 'fetch_all_mail';
export const FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
export const GET_IMPORTANT_MAIL = 'get_important_mail';
export const GET_NAV_FILTERS = 'get_nav_filters';
export const GET_NAV_LABELS = 'get_nav_labels';
export const GET_NAV_FOLDER = 'get_nav_folder';
export const GET_READ_MAIL = 'get_read_mail';
export const GET_STARRED_MAIL = 'get_starred_mail';
export const GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
export const GET_UNREAD_MAIL = 'get_unread_mail';
export const GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
export const GET_UNSTARRED_MAIL = 'get_unstarred_mail';
export const ON_ALL_MAIL_SELECT = 'on_all_mail_select';
export const ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
export const ON_FOLDER_SELECT = 'on_folder_select';
export const ON_IMPORTANT_SELECT = 'on_important_select';
export const ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
export const GET_MARK_AS_START = 'get_mark_as_start';
export const ON_LABEL_SELECT = 'on_label_select';
export const ON_MAIL_CHECKED = 'on_mail_checked';
export const ON_MAIL_SELECT = 'on_mail_select';
export const ON_MAIL_SEND = 'on_mail_send';
export const ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
export const ON_OPTION_MENU_SELECT = 'on_option_menu_select';
export const ON_START_SELECT = 'on_start_select';
export const SEARCH_MAIL = 'search_mail';
export const ON_DELETE_MAIL = 'on_delete_mail';
export const SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
export const ON_COMPOSE_MAIL = 'on_compose_mail';

//// TO-DO Module const

export const ON_SORTEND = 'on_sortend';
export const FETCH_ALL_TODO = 'fetch_all_todo';
export const FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
export const FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
export const SELECT_ALL_TODO = 'select_all_todo';
export const GET_ALL_TODO = 'get_all_todo';
export const GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
export const GET_STARRED_TODO = 'get_starred_todo';
export const GET_UNSTARRED_TODO = 'get_unstarred_todo';
export const GET_IMPORTANT_TODO = 'get_important_todo';
export const GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
export const ON_LABEL_UPDATE = 'on_label_update';
export const ON_TODO_UPDATE = 'on_todo_update';
export const ON_DELETE_TODO = 'on_delete_todo';
export const SEARCH_TODO = 'search_todo';
export const SHOW_TODOS = 'show_todos';
export const GET_TODO_CONVERSATION = 'get_todo_conversation';
export const ON_TODO_CHECKED = 'on_todo_checked';
export const ON_TODO_ADD = 'on_todo_add';
export const ON_TODO_SELECT = 'on_todo_select';
export const SET_CURRENT_TODO_NULL = 'set_current_todo_null';
export const REMOVE_LABEL = 'remove_label';
export const UPDATE_SEARCH = 'update_search';

